/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // fixing the STOQ pre-order button layout issue on product page
    var isProductPage = window.location.pathname.indexOf('/products/') === 0;
  if (!isProductPage) return;

  if (document.getElementById('frcp-restock-rocket-grid-fix')) return;

  var css =
    '.product__submit__item--inline .restock-rocket-acknowledgement-checkbox {' +
      'grid-row: 1; grid-column: 1 / -1;' +
    '}' +
    '.product__submit__item--inline .product-form__input {' +
      'grid-row: 2; grid-column: 1;' +
    '}' +
    '.product__submit__item--inline .btn {' +
      'grid-row: 2; grid-column: 2;' +
    '}' +
    '.product__submit__item--inline .frcp-wishlist-wrapper {' +
      'grid-row: 2; grid-column: 3;' +
    '}' +
    '.product__submit__item--inline .restock-rocket-preorder-description {' +
      'grid-row: 3; grid-column: 1 / -1;' +
      'margin-top: 0px !important;' +
      'padding-left: 0px !important;' +
      'padding-right: 0px !important;' +
    '}';

  var styleEl = document.createElement('style');
  styleEl.id = 'frcp-restock-rocket-grid-fix';
  styleEl.appendChild(document.createTextNode(css));
  document.head.appendChild(styleEl);
  // end of STOQ pre-order button layout issue on product page
  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
